// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BannerController from "./banner_controller"
application.register("banner", BannerController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CopyrightController from "./copyright_controller"
application.register("copyright", CopyrightController)

import CursorController from "./cursor_controller"
application.register("cursor", CursorController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FormController from "./form_controller"
application.register("form", FormController)

import ImageController from "./image_controller"
application.register("image", ImageController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ResendController from "./resend_controller"
application.register("resend", ResendController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SheetController from "./sheet_controller"
application.register("sheet", SheetController)

import SubmitNowController from "./submit_now_controller"
application.register("submit-now", SubmitNowController)

import TextareaController from "./textarea_controller"
application.register("textarea", TextareaController)

import TranxactionFormController from "./tranxaction_form_controller"
application.register("tranxaction-form", TranxactionFormController)

import Treegrid__AtomController from "./treegrid/atom_controller"
application.register("treegrid--atom", Treegrid__AtomController)

import Treegrid__CellController from "./treegrid/cell_controller"
application.register("treegrid--cell", Treegrid__CellController)

import Treegrid__RowController from "./treegrid/row_controller"
application.register("treegrid--row", Treegrid__RowController)

import TreegridController from "./treegrid_controller"
application.register("treegrid", TreegridController)
